<script setup lang="ts">
import type { PropType } from 'vue';

import type { AssetSpecValue, AssetSpecColor } from '~/types/asset.type';

// PROPS
const { color } = defineProps({
    name: { type: String as PropType<TypedTranslateReturn>, required: true },
    value: { type: [String, Number, Boolean, null] as PropType<AssetSpecValue>, required: true },
    color: { type: String as PropType<AssetSpecColor>, default: undefined },
});

// DATA
const isColorVariant = computed(() => !!color);
const icon = computed(() => {
    switch (color) {
        case 'success':
            return { name: 'lucide:circle-check', class: 'text-success-500' };
        case 'warning':
            return { name: 'lucide:circle-alert', class: 'text-warning-500' };
        case 'error':
            return { name: 'lucide:triangle-alert', class: 'text-error-500' };

        default:
            return undefined;
    }
});
</script>

<template>
    <p v-if="typeof value === 'boolean'" class="flex items-center">
        <UIcon v-if="value" name="lucide:circle-check" class="text-success-500" />
        <UIcon v-else name="lucide:circle-x" class="text-dimmed" />
        <span class="ml-2" :class="{ 'line-through': !value }">{{ name }}</span>
    </p>
    <p v-else-if="isColorVariant" class="flex flex-col">
        <span class="flex items-center gap-2"> <UIcon v-if="icon" :name="icon.name" :class="icon.class" /> {{ name }}</span>
        <span class="text-dimmed">{{ value }}</span>
    </p>
    <p v-else-if="value !== null">
        {{ name }}:&nbsp; <span class="text-primary">{{ value }}</span>
    </p>
</template>
